<h1>
  {{ (customer$ | async)?.firstName }} {{ (customer$ | async)?.lastName }}
</h1>

<mat-tab-group>
  <mat-tab label="Profile">
    <customer-form
      [mode]="mode"
      [loading]="loading | async"
      [customer]="customer$ | async"
      (locationRequest)="locationRequest($event)"
      [location]="location$ | async"
      [locationLoading]="locationLoading$ | async"
      [queryString]="'access_token=' + (token$ | async)"
      (submitted)="submitCustomer($event)"
    ></customer-form>
  </mat-tab>

  <mat-tab label="Team">
    <div fxLayout="row" fxLayoutAlign="start ">
      <div fxFlex="1 0 auto">
        <h2>Assigned Team Members</h2>
      </div>
      <div fxFlex="0 0 auto" fxLayoutGap="15px" fxFlexAlign="center">
        <button mat-flat-button color="primary" (click)="showAddTeamDialog()">
          Add To Team
        </button>
      </div>
    </div>
    <div *ngIf="(customerTeam$ | async).length > 0; else noTeam">
      <customer-team-table
        (removeMember)="removeMember($event)"
        (removeMember)="removeMember($event)"
        [team]="customerTeam$ | async"
      ></customer-team-table>
    </div>
    <ng-template #noTeam>
      <p>No team members assigned to this community</p>
    </ng-template>

    <h2 class="more-padding">Pending Invitations</h2>

    <div *ngIf="(invites.data | async).length > 0; else noInvites">
      <data-list-table
        [config]="inviteConfig"
        [link]="false"
        [dataSource]="invites"
      >
        <invite-actions
          *dataListCellRenderer="'actions'; let row"
          [id]="row.id"
          (cancel)="cancelInvite($event)"
          (resend)="resendInvite($event)"
        ></invite-actions>
      </data-list-table>
    </div>

    <ng-template #noInvites>
      <p>No pending invites to join this community</p>
    </ng-template>
  </mat-tab>
  <mat-tab label="Files">
    <div class="files">
      <customer-files-table
        [files]="customerFiles$ | async"
        [token]="token$ | async"
        (removeFile)="removeFile($event)"
      ></customer-files-table>

      <ca-file-picker
        (newFile)="uploadFile($event)"
        [loading]="uploading$ | async"
      ></ca-file-picker>
    </div>

    <h2>Links</h2>
    <customer-links-form
      [mode]="mode"
      [loading]="loading | async"
      [customer]="customer$ | async"
      [queryString]="'access_token=' + (token$ | async)"
      (submitted)="submitCustomer($event)"
    ></customer-links-form>
  </mat-tab>
  <mat-tab label="Settings">
    <h2>Community Preferences</h2>
    <customer-preferences-form
      [customer]="customer$ | async"
      [loading]="loading | async"
      [mode]="mode"
      (submitted)="submitCustomer($event)"
    >
    </customer-preferences-form>
  </mat-tab>
</mat-tab-group>
<mat-tab label="Team">
  <div fxLayout="row" fxLayoutAlign="start ">
    <div fxFlex="1 0 auto">
      <h2>Assigned Team Members</h2>
    </div>
    <div fxFlex="0 0 auto" fxLayoutGap="15px" fxFlexAlign="center">
      <button mat-flat-button color="primary">
        Add To Team
      </button>
    </div>
  </div>
  <customer-team-table
    (removeMember)="removeMember($event)"
    (removeMember)="removeMember($event)"
    [team]="customerTeam$ | async"
  ></customer-team-table>
</mat-tab>
